/* Botsway Simple theme script. No dependencies. */
(() => {
  'use strict';
  const BW = window.BW || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' }, moneyFormat: '${{amount}}', cartType: 'drawer' };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const nf = new Intl.NumberFormat('en-GB');
  const money = (cents, trim = true) => {
    const v = Number(cents) / 100;
    const whole = Number.isInteger(v);
    const amount = whole && trim ? nf.format(v) : v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return BW.moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  function toast(msg) {
    const t = $('#bw-toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(() => { t.hidden = true; }, 3200);
  }

  /* ------------------------------------------------------------ drawers (dialog) */
  function openDrawer(id, opener) {
    const d = document.getElementById(id);
    if (!d || d.open) return;
    d._opener = opener || document.activeElement;
    d.classList.remove('is-closing');
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(d) {
    if (!d || !d.open) return;
    const done = () => {
      d.classList.remove('is-closing');
      d.close();
      document.documentElement.style.overflow = '';
      if (d._opener && d._opener.focus) d._opener.focus();
    };
    if (reduced()) return done();
    d.classList.add('is-closing');
    d.addEventListener('animationend', done, { once: true });
    setTimeout(() => { if (d.open && d.classList.contains('is-closing')) done(); }, 400);
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.open, opener); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { closeDrawer(closer.closest('dialog')); return; }
    if (e.target.matches('dialog.drawer')) {
      const r = e.target.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDrawer(e.target);
    }
  });
  document.addEventListener('cancel', (e) => {
    if (e.target.matches('dialog.drawer')) { e.preventDefault(); closeDrawer(e.target); }
  }, true);

  /* ------------------------------------------------------------ header */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------ predictive search */
  const search = $('[data-search]');
  if (search) {
    const input = $('input[type="search"]', search);
    const box = $('#predict', search);
    const toggle = $('[data-search-toggle]');
    let ctrl, timer, active = -1;
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const items = () => $$('.predict__item, .predict__all', box);
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      ctrl?.abort();
      ctrl = new AbortController();
      try {
        const url = `${BW.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor,tag&section_id=predictive-search`;
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) return;
        const doc = parseHTML(await res.text());
        const inner = $('#predict-results', doc);
        box.innerHTML = inner ? inner.outerHTML : '';
        box.hidden = !inner;
        input.setAttribute('aria-expanded', inner ? 'true' : 'false');
        active = -1;
      } catch (_) { /* aborted */ }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', () => { if (box.innerHTML.trim() && input.value.trim().length > 1) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    input.addEventListener('keydown', (e) => {
      const list = items();
      if (e.key === 'Escape') { close(); return; }
      if (!list.length || box.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
        list.forEach((el, i) => el.setAttribute('aria-selected', i === active ? 'true' : 'false'));
        list[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        list[active].click();
      }
    });
    document.addEventListener('click', (e) => { if (!search.contains(e.target) && e.target !== toggle && !toggle?.contains(e.target)) { close(); search.classList.remove('is-open'); } });
    toggle?.addEventListener('click', () => { search.classList.toggle('is-open'); if (search.classList.contains('is-open')) input.focus(); });
  }

  /* ------------------------------------------------------------ cart */
  const drawer = () => document.getElementById('cart-drawer');
  const cartPageSection = () => {
    const el = $('[data-cart-page]');
    const s = el && el.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : null;
  };
  function sectionIds() {
    const ids = [];
    if (drawer()) ids.push('cart-drawer');
    const page = cartPageSection();
    if (page) ids.push(page);
    return ids;
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; });
    $$('[data-cart-open]').forEach((el) => el.setAttribute('aria-label', `Cart, ${n} item${n === 1 ? '' : 's'}`));
    $$('[data-cart-n]').forEach((el) => { el.textContent = n > 0 ? `(${n})` : ''; });
  }
  function applySections(sections) {
    if (!sections) return;
    for (const [id, html] of Object.entries(sections)) {
      if (!html) continue;
      const doc = parseHTML(html);
      const fresh = $('[data-cart-inner]', doc);
      const target = id === 'cart-drawer' ? $('#cart-drawer [data-cart-inner]') : $('[data-cart-page] [data-cart-inner]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    }
  }
  async function cartAdd(form, submitter) {
    const btn = submitter || $('[type="submit"]', form);
    const errBox = $('[data-form-error]', form);
    if (errBox) errBox.hidden = true;
    btn?.classList.add('is-loading');
    btn?.setAttribute('aria-disabled', 'true');
    const fd = new FormData(form);
    const ids = sectionIds();
    if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
    try {
      const res = await fetch(`${BW.routes.cartAdd}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const json = await res.json();
      if (!res.ok || json.status) {
        const msg = json.description || json.message || 'That could not be added. Please try again.';
        if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else toast(msg);
        return;
      }
      applySections(json.sections);
      const cart = await fetch(`${BW.routes.cart}.js`).then((r) => r.json());
      setCount(cart.item_count);
      if (btn && btn.classList.contains('add-sm')) {
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
      }
      if (BW.cartType === 'drawer' && drawer()) openDrawer('cart-drawer', btn);
      else if (!drawer()) toast('Added to your cart');
    } catch (e) {
      form.submit();
    } finally {
      btn?.classList.remove('is-loading');
      btn?.removeAttribute('aria-disabled');
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('form.js-add')) {
      e.preventDefault();
      cartAdd(form, e.submitter);
    } else if (form.matches('[data-confirm]') && !window.confirm(form.dataset.confirm)) {
      e.preventDefault();
    }
  });
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawer() && BW.cartType === 'drawer') { e.preventDefault(); openDrawer('cart-drawer', open); }
  });

  let changeTimer;
  async function cartChange(line, quantity, row) {
    row?.classList.add('is-busy');
    try {
      const res = await fetch(`${BW.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionIds(), sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!res.ok || json.status) {
        row?.classList.remove('is-busy');
        toast(json.description || json.message || 'That quantity is not available.');
        return;
      }
      applySections(json.sections);
      setCount(json.item_count);
    } catch (_) {
      window.location.reload();
    }
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (rm) { cartChange(Number(rm.dataset.remove), 0, rm.closest('.cline')); return; }
    const step = e.target.closest('[data-qty] [data-step]');
    if (!step) return;
    const wrap = step.closest('[data-qty]');
    const input = $('input', wrap);
    const min = Number(input.min || 0);
    const next = Math.max(min, (Number(input.value) || 0) + Number(step.dataset.step));
    input.value = next;
    if (input.dataset.lineQty) {
      clearTimeout(changeTimer);
      changeTimer = setTimeout(() => cartChange(Number(input.dataset.lineQty), next, input.closest('.cline')), 300);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) cartChange(Number(input.dataset.lineQty), Math.max(0, Number(input.value) || 0), input.closest('.cline'));
    const auto = e.target.closest('[data-autosubmit]');
    if (auto && auto.form) auto.form.requestSubmit ? auto.form.requestSubmit() : auto.form.submit();
  });

  /* ------------------------------------------------------------ product page */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const track = $('[data-track]', gallery);
    const slides = $$('[data-slide]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    const count = $('[data-count]', gallery);
    const go = (i) => {
      const n = slides.length;
      const k = (i + n) % n;
      track.scrollTo({ left: slides[k].offsetLeft, behavior: reduced() ? 'auto' : 'smooth' });
    };
    const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    let st;
    track.addEventListener('scroll', () => {
      clearTimeout(st);
      st = setTimeout(() => {
        const i = index();
        thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (count) count.textContent = `${i + 1} / ${slides.length}`;
      }, 60);
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    $('[data-prev]', gallery)?.addEventListener('click', () => go(index() - 1));
    $('[data-next]', gallery)?.addEventListener('click', () => go(index() + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
  }

  const vsel = $('[data-variant-select]');
  if (vsel) {
    vsel.addEventListener('change', () => {
      const o = vsel.selectedOptions[0];
      const avail = o.dataset.avail === 'true';
      const priceEl = $('[data-product] .price__now');
      if (priceEl) priceEl.textContent = o.dataset.price;
      const sp = $('[data-sticky-price]');
      if (sp) sp.textContent = o.dataset.price;
      const add = $('[data-add]');
      if (add) { add.disabled = !avail; add.textContent = avail ? 'Add to cart' : 'Sold out'; }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', vsel.value);
      history.replaceState(null, '', url);
    });
  }

  const sticky = $('[data-sticky-buy]');
  const mainAdd = $('[data-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([en]) => {
      const on = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      $('[data-sticky-add]', sticky).tabIndex = on ? 0 : -1;
    });
    io.observe(mainAdd);
    $('[data-sticky-add]', sticky).addEventListener('click', (e) => {
      const form = $('.js-main-form');
      if (form) cartAdd(form, e.currentTarget);
    });
  }

  const recs = $('[data-recs]');
  if (recs && !recs.children.length) {
    fetch(recs.dataset.url).then((r) => r.text()).then((html) => {
      const fresh = $('[data-recs]', parseHTML(html));
      if (fresh && fresh.innerHTML.trim()) recs.innerHTML = fresh.innerHTML;
    }).catch(() => {});
  }

  $$('[data-clamp]').forEach((box) => {
    const more = box.parentElement.querySelector('[data-clamp-more]');
    if (box.scrollHeight <= box.clientHeight + 48) { box.classList.remove('clamp'); return; }
    if (!more) return;
    more.hidden = false;
    more.addEventListener('click', () => { box.classList.add('is-open'); more.remove(); });
  });

  /* ------------------------------------------------------------ account bits */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-show-recover]');
    if (!t) return;
    e.preventDefault();
    $('[data-login]').hidden = true;
    $('[data-recover]').hidden = false;
    $('[data-recover] input[type="email"]')?.focus();
  });
  if (window.location.hash === '#recover' && $('[data-recover]')) { $('[data-login]').hidden = true; $('[data-recover]').hidden = false; }
  $$('select[data-default]').forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });
})();
